import { Entry } from 'contentful';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { IFAQData } from '../FAQ';
import { TypeFaqEntrySkeleton } from '@generated/contentful';

interface IProps {
  faqs: (Entry<TypeFaqEntrySkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | undefined)[];
}

/**
 * Transforms an array of Contentful FAQ entries into an array of `IFAQData` objects.
 *
 * Each FAQ entry is mapped to an object containing:
 * - `id`: A string identifier based on the index.
 * - `title`: The FAQ question.
 * - `body`: The FAQ answer rendered as React components.
 * - `bodyString`: The FAQ answer rendered as an HTML string.
 *
 * Filters out any undefined entries before mapping.
 *
 * @param faqs - An array of Contentful FAQ entries, possibly containing undefined values.
 * @returns An array of `IFAQData` objects suitable for rendering in the FAQ component.
 */
export const getFAQDataFromContentful = ({ faqs }: IProps): IFAQData[] => {
  return faqs
    .filter((faq): faq is Entry<TypeFaqEntrySkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> => !!faq)
    .map((faq, index) => {
      return {
        id: `${index}`,
        title: faq.fields.question,
        body: <>{documentToReactComponents(faq.fields.answer)}</>,
        bodyString: documentToHtmlString(faq.fields.answer),
      };
    });
};
